import { render, staticRenderFns } from "./UserSidebarComponent.vue?vue&type=template&id=796acb4c&"
import script from "./UserSidebarComponent.vue?vue&type=script&lang=js&"
export * from "./UserSidebarComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserSidebarComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports